import { Layout, Button, Form, Table, Input } from "antd";
import { Link } from "react-router-dom";
import SideNavBar from "../../Components/SideBar/Sidebar";
import Navbar from "../../Components/Support/Header";
import axios from "axios";
import { useState, useEffect } from "react";
import {
  PlusOutlined,
  SearchOutlined,
  EditOutlined,
  CloseOutlined,
  CheckOutlined,
} from "@ant-design/icons";
import Cookies from "js-cookie";
import { AddNewGlCode } from "../../Repository/CorporateExpenseManageRepository";
import { ErrorMessage, InfoMessage, SuccessMessage } from "../../Utils/Utils";
const GlCodes = () => {
  const { Header, Content } = Layout;
  const jwtToken = Cookies.get("jwt_token");
  const [form] = Form.useForm();
  const [data, setData] = useState([]);
  const [oldData, setOldData] = useState([]);
  const [loading, setLoading] = useState(true);
  const isEditing = (record) => record.exp_id === CurrentEditingKey;
  const [SearchGrid, setSearchGrid] = useState("");
  const [CurrentEditingKey, setCurrentEditingKey] = useState("");
  const [NewRecordKey, setNewRecordKey] = useState(null);

  const GetTableData = () => {
    axios
      .get(`${process.env.REACT_APP_BASE_URL}ExpenseReim/GetGLcode`, {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "Access-Control-Allow-Origin": "*",
          Authorization: `Bearer ${jwtToken}`,
        },
      })
      .then((response) => {
        setData(response.data.result);
        setLoading(false);
        setCurrentEditingKey("");
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  };

  useEffect(() => {
    GetTableData();
  }, []);
  const handleAddNewGlCode = async (record) => {
    const NewRecord = form.getFieldsValue();
    const allFieldsBlank = Object.values(NewRecord).every(value =>
      value === null || value === undefined || value === ""
    );
  
    if (allFieldsBlank) {
      ErrorMessage("Cannot add a blank record. Fill in at least one field.");
      return;
    }
    NewRecord.exp_id = record.exp_id;
    const Response = await AddNewGlCode(NewRecord);

    Response.isCompleted === true
      ? SuccessMessage("Record Added Successfully")
      : InfoMessage("Update Failed");
    GetTableData();
    setCurrentEditingKey("");
  };

  const AddNewRecord = async () => {
    // console.log(CurrentEditingKey);

    if (CurrentEditingKey === "") {
      let NewRecordArray = {};
      for (let index in columns) {
        NewRecordArray[columns[index].dataIndex] = "";
      }

      NewRecordArray.exp_id = "0";
      setOldData([...data]);
      setData([NewRecordArray, ...data]);

      form.setFieldsValue({ ...NewRecordArray });
      setNewRecordKey("0");
      setCurrentEditingKey("0");
    } else {
      InfoMessage("Please save/discard the record");
    }
  };
  //Filter Feature for Grid Layout
  const filterProps = () => ({
    filteredValue: [SearchGrid],
    onFilter: (value, record) => {
      return (
        String(record.exp_id)
          .toLowerCase()
          .includes(String(value).toLowerCase()) ||
        String(record.codes_in_paychex)
          .toLowerCase()
          .includes(String(value).toLowerCase()) ||
        String(record.gL_Name).toLowerCase().includes(value.toLowerCase())
      );
    },
  });
  const SearchEmployee = (value) => {
    console.log(value);
    setSearchGrid(value);
  };
  const columns = [
    // {
    //   title: "Exp ID",
    //   dataIndex: "exp_id",
    //   width: 80,
    //   fixed: "left",
    //   editable: true,
    // },

    {
      title: "Codes in Paychex",
      dataIndex: "codes_in_paychex",
      // width: 70,
      // fixed: "left",
      editable: true,
      ...filterProps(),
    },

    {
      title: "GL Name",
      dataIndex: "gL_Name",
      // width: 50,
      // fixed: "left",
      editable: true,
      ...filterProps(),
    },
    {
      title: "GL Account #",
      dataIndex: "gL_Account",
      // width: 80,
      // fixed: "left",
      editable: true,
    },
    {
      title: "Action",
      key: "edit",
      fixed: "right",
      width: 60,
      render: (_, record) => {
        return (
          <>
            {isEditing(record) ? (
              // When isEditing is true
              <div>
                {record.exp_id === NewRecordKey ? (
                  // When NewRecordKey is "tempId"
                  <PlusOutlined onClick={() => handleAddNewGlCode(record)} />
                ) : null}

                <CloseOutlined
                  style={{ color: "red" }}
                  onClick={() => {
                    if (record.exp_id === NewRecordKey) {
                      setData(oldData);
                      setCurrentEditingKey("");
                      setNewRecordKey("");
                    } else {
                      setCurrentEditingKey("");
                      setNewRecordKey("");
                    }
                  }}
                />
              </div>
            ) : null}
          </>
        );
      },
    },
  ];
  const EditableCell = ({
    editing,
    dataIndex,
    title,
    record,
    index,
    children,
    ...restProps
  }) => {
    return (
      <td {...restProps}>
        {editing ? (
          <Form.Item
            name={dataIndex}
            style={{
              margin: 0,
            }}
            // rules={[
            //   {
            //     required: true,
            //     message: `Please Input ${title}!`,
            //   },
            // ]}
          >
            <Input />
          </Form.Item>
        ) : (
          children
        )}
      </td>
    );
  };
  const mergedColumns = columns.map((col) => {
    if (!col.editable) {
      return col;
    }
    return {
      ...col,
      onCell: (record) => ({
        record,
        dataIndex: col.dataIndex,
        title: col.title,
        editing: isEditing(record),
      }),
    };
  });

  return (
    <div className="timecards-container">
      <Layout style={{ backgroundColor: "white", overflow: "hidden" }}>
        <SideNavBar />
        <Layout className="timecards-sub-layout-container">
          <Header className="timecards-header">
            <Navbar />
          </Header>
          <Content>
            <div>
              <div className="expensepages">
                <Link to="/contingentexpensemanagement">
                  <Button className="page-button">
                    ContingentExpenseManagement
                  </Button>
                </Link>
                <Link to="/corporateexpensemanagement">
                  <Button className="page-button">
                    CorporateExpenseManagement
                  </Button>
                </Link>
                <Link to="/glcodes">
                  <Button className="currentpreview-button">GL Code</Button>
                </Link>
              </div>
              <div className="addnew-row">
                <Button className="row-button" onClick={() => AddNewRecord()}>
                  Add New GL Code <PlusOutlined />
                </Button>
                <Input
                  placeholder="Search with Codes in Paychex,GL Name"
                  className="input-searchrow"
                  style={{ borderColor: "#002766", color: "#F4F9FF" }}
                  onChange={(e) => SearchEmployee(e.target.value)}
                  suffix={
                    <SearchOutlined
                      style={{
                        color: "#002766",
                        justifyContent: "space-between",
                      }}
                    />
                  }
                />
              </div>
              <div className="contingent-table">
                <Form form={form} component={false}>
                  <Table
                    components={{
                      body: {
                        cell: EditableCell,
                        
                      },
                    }}
                    // onRow={(record, rowIndex) => {
                    //   return {
                    //     onMouseEnter: (event) => {
                    //       // console.log("gfcuybluhoul");
                    //     },
                    //   };
                    // }}
                    columns={mergedColumns}
                    dataSource={data}
                    pagination={false}
                    scroll={{ x: "max-content", y: 400 }}
                    loading={loading}
                    bordered
                  />
                </Form>
              </div>
            </div>
          </Content>
        </Layout>
      </Layout>
    </div>
  );
};

export default GlCodes;
